export default {
  'ach.passthru.send': 'Send ACH File',
  'ach.passthru.filename': 'File Name',
  'ach.passthru.incomingFilename': 'Incoming File Name',
  'ach.passthru.totalbatches': 'Total Batches',
  'ach.passthru.totaldebits': 'Total Debits',
  'ach.passthru.totalcredits': 'Total Credits',
  'ach.passthru.uploadedby': 'Uploaded By',
  'ach.passthru.uploadeddate': 'Uploaded Date',
  'ach.passthru.approvedBy': 'Approved By',
  'ach.passthru.approvedDt': 'Approved Date',
  'ach.passthru.initiatedBy': 'Initiated By',
  'ach.passthru.initiatedDt': 'Initiated Date',
  'ach.passthru.status': 'Status',
  'ach.passthru.reason': 'Reason',
  'ach.passthru.uploads.failed.title': 'Failed Uploads',
  'ach.batch.details.routingNumber': 'Bank Code / Number',
  'ach.batch.details.creditOrDebit': 'Credit/Debit',
  'ach.batch.details.typeOfItem': 'Type',
  'passthru.fileHas': 'File has been ',
  'passthru.delete.warning': 'Delete File',
  'passthru.delete.content': 'Are you sure you want to delete this file?',
  'passthru.delete.confirm': 'This action can not be undone',
  'passthru.delete.success': 'File has been deleted',
  'passthru.delete.failure': 'File was not deleted',
  'passthru.approve.warning': 'Approve File',
  'passthru.approve.content': 'Are you sure you want to approve this file?',
  'passthru.approve.success': '<%=fileName %> has been approved',
  'passthru.approve.failure': '<%=fileName %> has not been approved',
  'passthru.accept.warning': 'Submit',
  'passthru.accept.content': 'Are you sure you want to submit this file?',
  'passthru.submitForApproval.warning': 'Submit for Approval',
  'passthru.submitForApproval.content': 'Are you sure you want to submit this file for approval?',
  'passthru.accept.success': '<%=fileName %> File has been submitted',
  'passthru.accept.failure': '<%=fileName %> File was not submitted',
  'passthru.warningsFound': 'Warning<%=ending %> Found',
  'passthru.viewDetails': 'View Details',
  'passthru.errors.PASSTHRU.FILE_ALREADY_DELETED': 'File has already been deleted',
  'passthru.errors.PASSTHRU.VALIDATION_BATCH_NOT_FOUND': 'There are no batches in required file',
  'passthru.errors.PASSTHRU.VALIDATION_FILE_NOT_FOUND': 'Validation file not found',
  'passthru.errors.COMMON.DATA_ACCESS_ERROR': 'Error accessing data',
  'passthru.errors.fileUploaded': 'File Cannot Be Uploaded',
  'passthru.errors.fileUploadCancelled': 'File Upload Cancelled',
  'passthru.upload.message': 'Upload NACHA Supported File',
  'passthru.upload.success': 'File Upload Successful',
  'passthru.upload.failed': 'File Upload Failed',
  'passthru.upload.warning': 'Error found in Batch ',
  'passthru.upload.processing': 'File Processing...',
  'passthru.upload.duplicateError': 'File cannot be uploaded - Duplicate File',
  'passthru.fileMessages.title': 'Upload Messages',
  'passthru.fileMessages.lineNumber': 'Line Number',
  'passthru.submit.success': '<%=fileName %> File has been submitted',
  'passthru.submit.failure': '<%=fileName %> File was not submitted',
  'passthru.submitForApproval.success': '<%=fileName %> File has been submitted for approval',
  'passthru.submitForApproval.failure': '<%=fileName %> File was not submitted for approval',
  'passthru.potentialDuplicateFile': 'Potential Duplicate File',
  'passthru.potentialDuplicateFileDescription':
    'The file name and header record data on the ACH file match this previously uploaded file.',
  'passthru.proceedDuplicate': 'Do you want to continue?',
  'passthru.incomingFileName': 'Incoming File Name',
  'passthru.headerRecord': 'Header Record',
  'passthru.fileName': 'File Name',
  'passthru.uploadedBy': 'Uploaded By',
  'passthru.uploadedDt': 'Uploaded Date',
  'passthru.allFiles': 'All Files',
  'passthru.requireMyApproval': 'Requires my approval'
};
